/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChildTrackingNumberVo } from './ChildTrackingNumberVo';
import {
    ChildTrackingNumberVoFromJSON,
    ChildTrackingNumberVoFromJSONTyped,
    ChildTrackingNumberVoToJSON,
    ChildTrackingNumberVoToJSONTyped,
} from './ChildTrackingNumberVo';

/**
 * 
 * @export
 * @interface OrderBoxTrackingNumberVo
 */
export interface OrderBoxTrackingNumberVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderBoxTrackingNumberVo
     */
    orderId?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderBoxTrackingNumberVo
     */
    orderCode?: string;
    /**
     * 主运单号
     * @type {string}
     * @memberof OrderBoxTrackingNumberVo
     */
    mainTrackingNumber?: string;
    /**
     * 子运单号列表
     * @type {Array<ChildTrackingNumberVo>}
     * @memberof OrderBoxTrackingNumberVo
     */
    subTrackingNumberList?: Array<ChildTrackingNumberVo>;
    /**
     * 总箱数
     * @type {number}
     * @memberof OrderBoxTrackingNumberVo
     */
    totalBoxCount?: number;
}

/**
 * Check if a given object implements the OrderBoxTrackingNumberVo interface.
 */
export function instanceOfOrderBoxTrackingNumberVo(value: object): value is OrderBoxTrackingNumberVo {
    return true;
}

export function OrderBoxTrackingNumberVoFromJSON(json: any): OrderBoxTrackingNumberVo {
    return OrderBoxTrackingNumberVoFromJSONTyped(json, false);
}

export function OrderBoxTrackingNumberVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderBoxTrackingNumberVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'mainTrackingNumber': json['mainTrackingNumber'] == null ? undefined : json['mainTrackingNumber'],
        'subTrackingNumberList': json['subTrackingNumberList'] == null ? undefined : ((json['subTrackingNumberList'] as Array<any>).map(ChildTrackingNumberVoFromJSON)),
        'totalBoxCount': json['totalBoxCount'] == null ? undefined : json['totalBoxCount'],
    };
}

export function OrderBoxTrackingNumberVoToJSON(json: any): OrderBoxTrackingNumberVo {
    return OrderBoxTrackingNumberVoToJSONTyped(json, false);
}

export function OrderBoxTrackingNumberVoToJSONTyped(value?: OrderBoxTrackingNumberVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'mainTrackingNumber': value['mainTrackingNumber'],
        'subTrackingNumberList': value['subTrackingNumberList'] == null ? undefined : ((value['subTrackingNumberList'] as Array<any>).map(ChildTrackingNumberVoToJSON)),
        'totalBoxCount': value['totalBoxCount'],
    };
}

